import { darken, lighten } from 'polished'

const foreground = '#ffffff'
const background = '#383838'
const backgroundDarker = darken(0.1, background)
const backgroundLighter = lighten(0.1, background)
const text = '#ffffff'
const danger = '#ff6080'
const dark = '#111111'
const light = '#eeeeee'
const primary = '#73b435'
const primaryLighter = '#c5e062'
const path = '#008de4'

const colors = {
  primary,
  primaryLighter,
  background,
  backgroundDarker,
  backgroundLighter,
  foreground,
  text,
  danger,
  dark,
  light,
  path,
}

export default colors
